import { getAnalytics, isSupported, logEvent } from 'firebase/analytics';
import app from '../firebase';

// isSupported() rejects in environments without the storage Analytics needs
// (e.g. Safari private browsing, some in-app webviews) — resolve to a single
// shared instance (or null) once, instead of every call re-checking support.
const analyticsInstance = isSupported()
  .then((supported) => (supported ? getAnalytics(app) : null))
  .catch(() => null);

// Fire-and-forget custom event logging. No-ops until Analytics is confirmed
// supported, and silently does nothing if it never becomes available.
export function trackEvent(name, params) {
  analyticsInstance.then((analytics) => {
    if (analytics) logEvent(analytics, name, params);
  });
}
